import React from 'react';
import PropTypes from 'prop-types';

import Logo from 'components/common/Logo';

import BurgerMenuToggle from './BurgerMenuToggle';
import NavItems from './NavItems';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';

const NavbarTopElements = ({ navbarPosition, handleBurgerMenuToggle, navbarCollapsed }) => (
	<>
		<BurgerMenuToggle navbarPosition={navbarPosition} handleBurgerMenu={handleBurgerMenuToggle} />
		<Logo at="navbar-top" width={80} height={70} id="topLogo" />
		<NavItems navbarPosition={navbarPosition} navbarCollapsed={navbarCollapsed} />
		<TopNavRightSideNavItem />
	</>
);

NavbarTopElements.propTypes = {
	navbarPosition: PropTypes.string,
	handleBurgerMenuToggle: PropTypes.func,
};

export default NavbarTopElements;